module.exports = __webpack_public_path__ + "img/az-logo copy.0b2c83cc.webp";